// extracted by mini-css-extract-plugin
module.exports = {"root":"Common_root__yMvFM","halfWidth":"Common_halfWidth__Q5tzp","input":"Common_input__aPSbw","label":"Common_label__ITZmH","asterix":"Common_asterix__31a5q"};